var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-PL"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PL",
    clipPath: "url(#clip-PL)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "poland_2_",
    "data-name": "poland (2)",
    transform: "translate(0 -85.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(0 85.337)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1546",
    "data-name": "Rectangle 1546",
    width: 48.001,
    height: 32,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1547",
    "data-name": "Rectangle 1547",
    width: 48.001,
    height: 16,
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1548",
    "data-name": "Rectangle 1548",
    width: 48.001,
    height: 16,
    transform: "translate(0 101.337)",
    fill: "#d80027"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl);
export default __webpack_public_path__ + "static/media/pl.2acf078f.svg";
export { ForwardRef as ReactComponent };